namespace h5_vm {

   export enum CustomSysprepFileOption {
      IMPORT_FILE = 1,
      CREATE_FILE = 2
   }

}
